"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WS_RTT_STATS_STOP = exports.WS_RTT_STATS_START = exports.UPDATE_NETWORK_RTT = exports.UPDATE_NETWORK_CONNECTED = exports.UPDATE_NETWORK = exports.START_BANDWIDTH_ESTIMATOR = exports.SET_BACKEND_TERMINATED = void 0;
var START_BANDWIDTH_ESTIMATOR = exports.START_BANDWIDTH_ESTIMATOR = 'START_BANDWIDTH_ESTIMATOR';
var UPDATE_NETWORK = exports.UPDATE_NETWORK = 'UPDATE_NETWORK';
var UPDATE_NETWORK_CONNECTED = exports.UPDATE_NETWORK_CONNECTED = 'UPDATE_NETWORK_CONNECTED';
var UPDATE_NETWORK_RTT = exports.UPDATE_NETWORK_RTT = 'UPDATE_NETWORK_RTT';
var WS_RTT_STATS_START = exports.WS_RTT_STATS_START = 'WS_RTT_STATS_START';
var WS_RTT_STATS_STOP = exports.WS_RTT_STATS_STOP = 'WS_RTT_STATS_STOP';
var SET_BACKEND_TERMINATED = exports.SET_BACKEND_TERMINATED = 'SET_BACKEND_TERMINATED';